// extracted by mini-css-extract-plugin
var _1 = "SearchView-module__aiAnswer--gO3_Q";
var _2 = "SearchView-module__animateUploadProgressBarWidth--zEyLZ";
var _3 = "SearchView-module__animatedBackground--MPh3o";
var _4 = "SearchView-module__container--zQNtQ";
var _5 = "SearchView-module__headerContainer--SSOYA";
var _6 = "SearchView-module__headerTitle--qNyLe";
var _7 = "SearchView-module__headerTitleContainer--QyUQq";
var _8 = "SearchView-module__keywords--JLwKW";
var _9 = "SearchView-module__loading--fhbic";
var _a = "SearchView-module__results--RDsnC";
var _b = "SearchView-module__verticalExtraContainer--kwoUB";
export { _1 as "aiAnswer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "headerContainer", _6 as "headerTitle", _7 as "headerTitleContainer", _8 as "keywords", _9 as "loading", _a as "results", _b as "verticalExtraContainer" }
